import { render, staticRenderFns } from "./PerformanceStatistics.vue?vue&type=template&id=7368cac3&scoped=true&"
import script from "./PerformanceStatistics.vue?vue&type=script&lang=js&"
export * from "./PerformanceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceStatistics.vue?vue&type=style&index=0&id=7368cac3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7368cac3",
  null
  
)

export default component.exports